module.exports = __webpack_public_path__ + "img/login1.f2fb5dc6.jpg";